// REACT
import { useContext } from "react";
import { useAuth0 } from "@auth0/auth0-react";

// ASSETS
import languagePack from "../assets/languages/languagePack";
import '../assets/styles/login.css';
import logo from '../assets/images/logo.png';
import { IoIosLogIn } from "react-icons/io";

// CONTEXT
import { maincontext } from "../context/maincontext";

// BOOTSTRAP
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Loading from "../components/common/Loading";

export default function Login(props) {
    const { language } = useContext(maincontext);
    const { loginWithRedirect } = useAuth0();

    // IN PROGRESS
    function login(e) {
        e.preventDefault();
        loginWithRedirect()
        // handleRedirect(instance)
    }

    return (
        <>
            <div className="login">
                <div>
                    <img alt="logo" src={logo} className="login_logo"></img>
                </div>
                <Form onSubmit={login}>
                    <div className="login_button_container">
                        {props.isLoading ? <Loading isLogin={true}/> :
                            <Button className="login_button" type="submit">
                                <div className="login_button_elements">
                                    <IoIosLogIn className="login_icon" />&nbsp;
                                    <span className="logintext">{languagePack[language].login.login_button}</span>
                                </div>
                            </Button>
                        }

                    </div>
                </Form>
            </div>
        </>

    )
}